import { useEffect } from "react";
import { useLocale } from "@/contexts/LocaleContext";

/**
 * Lädt große statische Sprachkataloge ausschließlich nach bewusster Sprachwahl.
 * Die deutsche SSR-Auslieferung, automatisierte Sheets-Daten und Formulare bleiben unberührt.
 */
export default function StaticContentTranslationLayer() {
  const { locale } = useLocale();

  useEffect(() => {
    if (locale === "de") return;
    let cancelled = false;
    let cleanup: (() => void) | undefined;

    void import("@/lib/staticContentTranslations")
      .then(async ({ applyStaticContentTranslations, loadStaticTranslationCatalog }) => {
        const catalog = await loadStaticTranslationCatalog(locale);
        if (!cancelled) cleanup = applyStaticContentTranslations(catalog);
      })
      .catch((error) => console.error("Statische Übersetzung konnte nicht geladen werden:", error));

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, [locale]);

  return null;
}
